module.exports = new __parcel__URL__("icons8-express-js.f07bf4be.svg").toString();